export const GET_PROFILE_DATA = 'GET_PROFILE_DATA'
export const GET_PROFILE_DATA_SUCCESS = 'GET_PROFILE_DATA_SUCCESS'
export const GET_PROFILE_DATA_FAIL = 'GET_PROFILE_DATA_FAIL'
export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA'
export const UPDATE_PROFILE_DATA_SUCCESS = 'UPDATE_PROFILE_DATA_SUCCESS'
export const UPDATE_PROFILE_DATA_FAIL = 'UPDATE_PROFILE_DATA_FAIL'
export const ADD_PROFILE_DATA = 'ADD_PROFILE_DATA'
export const ADD_PROFILE_DATA_SUCCESS = 'ADD_PROFILE_DATA_SUCCESS'
export const ADD_PROFILE_DATA_FAIL = 'ADD_PROFILE_DATA_FAIL'
